<script setup lang="ts">
    import { InputRow, Combobox } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import { computed } from 'vue';
    import type { SelectOption } from '@/types';
    import { useI18n } from 'vue-i18n';

    const { tm } = useI18n();

    const countryOptions = computed<SelectOption[]>(() => {
        const map = tm('employee.address.country_codes_array') as Record<string, string>;
        return Object.entries(map).map(([value, label]) => ({ value, label }));
    });

    defineProps<{
        form: any;
    }>();
</script>

<template>
    <div class="grid gap-3">
        <InputRow
            :form="form"
            name="address"
            label="employee.address.address"
            error-key="address.main.address"
        >
            <Input
                id="address"
                v-model="form.address.main.address"
                :placeholder="$t('employee.address.address')"
            />
        </InputRow>
        <InputRow
            :form="form"
            name="address2"
            label="employee.address.address2"
        >
            <Input
                id="address2"
                v-model="form.address.main.address2"
                :placeholder="$t('employee.address.address2')"
            />
        </InputRow>
        <InputRow
            :form="form"
            name="postal_code"
            label="employee.address.postal_code"
            error-key="address.main.postal_code"
        >
            <Input
                id="postal_code"
                v-model="form.address.main.postal_code"
                :placeholder="$t('employee.address.postal_code')"
                type="number"
                step="any"
            />
        </InputRow>
        <InputRow
            :form="form"
            name="city"
            label="employee.address.city"
            error-key="address.main.city"
        >
            <Input
                id="city"
                v-model="form.address.main.city"
                :placeholder="$t('employee.address.city')"
            />
        </InputRow>
        <InputRow
            :form="form"
            name="country_code"
            label="employee.address.country_code"
        >
            <Combobox
                id="country_code"
                v-model="form.address.main.country_code"
                :options="countryOptions"
                :placeholder="$t('employee.address.country_code')"
                :show-remove-button="false"
            />
        </InputRow>
    </div>
</template>
